import { Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type EmailPulseHeaderProps = {
  open: () => void;
};

const EmailPulseHeader = ({ open }: EmailPulseHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      whiteSpace="pre"
      spacing={0.5}
    >
      <Typography>{t('page.emailPulse.learnMoreText.learnMore')}</Typography>
      <Link
        component="button"
        variant="body2"
        onClick={() => {
          open();
        }}
      >
        {t('page.emailPulse.learnMoreText.link')}
      </Link>
    </Stack>
  );
};

export default EmailPulseHeader;
